/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.billing
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: billing.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as billing_pb from './billing_pb'; // proto import: "billing.proto"


export class BillingServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetUserBillingProfile = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/GetUserBillingProfile',
    grpcWeb.MethodType.UNARY,
    billing_pb.GetUserBillingProfileRequest,
    billing_pb.GetUserBillingProfileResponse,
    (request: billing_pb.GetUserBillingProfileRequest) => {
      return request.serializeBinary();
    },
    billing_pb.GetUserBillingProfileResponse.deserializeBinary
  );

  getUserBillingProfile(
    request: billing_pb.GetUserBillingProfileRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.GetUserBillingProfileResponse>;

  getUserBillingProfile(
    request: billing_pb.GetUserBillingProfileRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.GetUserBillingProfileResponse) => void): grpcWeb.ClientReadableStream<billing_pb.GetUserBillingProfileResponse>;

  getUserBillingProfile(
    request: billing_pb.GetUserBillingProfileRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.GetUserBillingProfileResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/GetUserBillingProfile',
        request,
        metadata || {},
        this.methodDescriptorGetUserBillingProfile,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/GetUserBillingProfile',
    request,
    metadata || {},
    this.methodDescriptorGetUserBillingProfile);
  }

  methodDescriptorTopUpBalance = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/TopUpBalance',
    grpcWeb.MethodType.UNARY,
    billing_pb.TopUpBalanceRequest,
    billing_pb.TopUpBalanceResponse,
    (request: billing_pb.TopUpBalanceRequest) => {
      return request.serializeBinary();
    },
    billing_pb.TopUpBalanceResponse.deserializeBinary
  );

  topUpBalance(
    request: billing_pb.TopUpBalanceRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.TopUpBalanceResponse>;

  topUpBalance(
    request: billing_pb.TopUpBalanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.TopUpBalanceResponse) => void): grpcWeb.ClientReadableStream<billing_pb.TopUpBalanceResponse>;

  topUpBalance(
    request: billing_pb.TopUpBalanceRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.TopUpBalanceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/TopUpBalance',
        request,
        metadata || {},
        this.methodDescriptorTopUpBalance,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/TopUpBalance',
    request,
    metadata || {},
    this.methodDescriptorTopUpBalance);
  }

  methodDescriptorGetTransactionHistory = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/GetTransactionHistory',
    grpcWeb.MethodType.UNARY,
    billing_pb.GetTransactionHistoryRequest,
    billing_pb.GetTransactionHistoryResponse,
    (request: billing_pb.GetTransactionHistoryRequest) => {
      return request.serializeBinary();
    },
    billing_pb.GetTransactionHistoryResponse.deserializeBinary
  );

  getTransactionHistory(
    request: billing_pb.GetTransactionHistoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.GetTransactionHistoryResponse>;

  getTransactionHistory(
    request: billing_pb.GetTransactionHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.GetTransactionHistoryResponse) => void): grpcWeb.ClientReadableStream<billing_pb.GetTransactionHistoryResponse>;

  getTransactionHistory(
    request: billing_pb.GetTransactionHistoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.GetTransactionHistoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/GetTransactionHistory',
        request,
        metadata || {},
        this.methodDescriptorGetTransactionHistory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/GetTransactionHistory',
    request,
    metadata || {},
    this.methodDescriptorGetTransactionHistory);
  }

  methodDescriptorGetExpenseHistory = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/GetExpenseHistory',
    grpcWeb.MethodType.UNARY,
    billing_pb.GetExpenseHistoryRequest,
    billing_pb.GetExpenseHistoryResponse,
    (request: billing_pb.GetExpenseHistoryRequest) => {
      return request.serializeBinary();
    },
    billing_pb.GetExpenseHistoryResponse.deserializeBinary
  );

  getExpenseHistory(
    request: billing_pb.GetExpenseHistoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.GetExpenseHistoryResponse>;

  getExpenseHistory(
    request: billing_pb.GetExpenseHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.GetExpenseHistoryResponse) => void): grpcWeb.ClientReadableStream<billing_pb.GetExpenseHistoryResponse>;

  getExpenseHistory(
    request: billing_pb.GetExpenseHistoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.GetExpenseHistoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/GetExpenseHistory',
        request,
        metadata || {},
        this.methodDescriptorGetExpenseHistory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/GetExpenseHistory',
    request,
    metadata || {},
    this.methodDescriptorGetExpenseHistory);
  }

  methodDescriptorGetProjectExpenseHistory = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/GetProjectExpenseHistory',
    grpcWeb.MethodType.UNARY,
    billing_pb.GetProjectExpenseHistoryRequest,
    billing_pb.GetProjectExpenseHistoryResponse,
    (request: billing_pb.GetProjectExpenseHistoryRequest) => {
      return request.serializeBinary();
    },
    billing_pb.GetProjectExpenseHistoryResponse.deserializeBinary
  );

  getProjectExpenseHistory(
    request: billing_pb.GetProjectExpenseHistoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.GetProjectExpenseHistoryResponse>;

  getProjectExpenseHistory(
    request: billing_pb.GetProjectExpenseHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.GetProjectExpenseHistoryResponse) => void): grpcWeb.ClientReadableStream<billing_pb.GetProjectExpenseHistoryResponse>;

  getProjectExpenseHistory(
    request: billing_pb.GetProjectExpenseHistoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.GetProjectExpenseHistoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/GetProjectExpenseHistory',
        request,
        metadata || {},
        this.methodDescriptorGetProjectExpenseHistory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/GetProjectExpenseHistory',
    request,
    metadata || {},
    this.methodDescriptorGetProjectExpenseHistory);
  }

  methodDescriptorCheckSufficientBalance = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/CheckSufficientBalance',
    grpcWeb.MethodType.UNARY,
    billing_pb.CheckSufficientBalanceRequest,
    billing_pb.CheckSufficientBalanceResponse,
    (request: billing_pb.CheckSufficientBalanceRequest) => {
      return request.serializeBinary();
    },
    billing_pb.CheckSufficientBalanceResponse.deserializeBinary
  );

  checkSufficientBalance(
    request: billing_pb.CheckSufficientBalanceRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.CheckSufficientBalanceResponse>;

  checkSufficientBalance(
    request: billing_pb.CheckSufficientBalanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.CheckSufficientBalanceResponse) => void): grpcWeb.ClientReadableStream<billing_pb.CheckSufficientBalanceResponse>;

  checkSufficientBalance(
    request: billing_pb.CheckSufficientBalanceRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.CheckSufficientBalanceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/CheckSufficientBalance',
        request,
        metadata || {},
        this.methodDescriptorCheckSufficientBalance,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/CheckSufficientBalance',
    request,
    metadata || {},
    this.methodDescriptorCheckSufficientBalance);
  }

  methodDescriptorDeductTaskCost = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/DeductTaskCost',
    grpcWeb.MethodType.UNARY,
    billing_pb.DeductTaskCostRequest,
    billing_pb.DeductTaskCostResponse,
    (request: billing_pb.DeductTaskCostRequest) => {
      return request.serializeBinary();
    },
    billing_pb.DeductTaskCostResponse.deserializeBinary
  );

  deductTaskCost(
    request: billing_pb.DeductTaskCostRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.DeductTaskCostResponse>;

  deductTaskCost(
    request: billing_pb.DeductTaskCostRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.DeductTaskCostResponse) => void): grpcWeb.ClientReadableStream<billing_pb.DeductTaskCostResponse>;

  deductTaskCost(
    request: billing_pb.DeductTaskCostRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.DeductTaskCostResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/DeductTaskCost',
        request,
        metadata || {},
        this.methodDescriptorDeductTaskCost,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/DeductTaskCost',
    request,
    metadata || {},
    this.methodDescriptorDeductTaskCost);
  }

  methodDescriptorReleaseTaskCostHold = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.billing.BillingService/ReleaseTaskCostHold',
    grpcWeb.MethodType.UNARY,
    billing_pb.ReleaseTaskCostHoldRequest,
    billing_pb.ReleaseTaskCostHoldResponse,
    (request: billing_pb.ReleaseTaskCostHoldRequest) => {
      return request.serializeBinary();
    },
    billing_pb.ReleaseTaskCostHoldResponse.deserializeBinary
  );

  releaseTaskCostHold(
    request: billing_pb.ReleaseTaskCostHoldRequest,
    metadata?: grpcWeb.Metadata | null): Promise<billing_pb.ReleaseTaskCostHoldResponse>;

  releaseTaskCostHold(
    request: billing_pb.ReleaseTaskCostHoldRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: billing_pb.ReleaseTaskCostHoldResponse) => void): grpcWeb.ClientReadableStream<billing_pb.ReleaseTaskCostHoldResponse>;

  releaseTaskCostHold(
    request: billing_pb.ReleaseTaskCostHoldRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: billing_pb.ReleaseTaskCostHoldResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.billing.BillingService/ReleaseTaskCostHold',
        request,
        metadata || {},
        this.methodDescriptorReleaseTaskCostHold,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.billing.BillingService/ReleaseTaskCostHold',
    request,
    metadata || {},
    this.methodDescriptorReleaseTaskCostHold);
  }

}

